{
    "SectionheaderReportoptions": "Report Options",
    "ReporttablabelStyle": "Style:",
    "ReporttablabelInterval": "Interval:",
    "ReporttablabelEntity": "Entity:",
    "ReporttablabelName": "Name:",
    "ReporttablabelFolder": "Folder:",
    "ReporttablabelNote": "Note:",
    "ReporttabReportnameoverwritePromptTextFormatString": "You have changed the report style of this report - Do you wish to automatically overwrite the existing name of the report with '|1'?",
    "NAME": "ReportOptions"
}